/* PDFORDER */
export const GET_FILEDOWNLOAD = "GET_FILEDOWNLOAD"
export const GET_FILEDOWNLOAD_SUCCESS = "GET_FILEDOWNLOAD_SUCCESS"
export const GET_FILEDOWNLOAD_FAIL = "GET_FILEDOWNLOAD_FAIL"